import { NgIf, NgFor } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CartLine } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { openProductSupplementDialog } from 'src/app/cart/store/actions';
import { AppState } from 'src/app/models/app.models';

@Component({
  templateUrl: './column-product-supplements.component.html',
  styleUrls: ['./column-product-supplements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatButton, MatIcon, NgFor, AgrI18nSharedModule],
})
export class ColumnProductSupplementsComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<Element>;

  public cartId: number;
  public editable: boolean;
  public initCallback: () => void;

  constructor(private readonly store: Store<AppState>) {}

  ngAfterViewInit() {
    this.initCallback();
  }

  public openProductSupplement(cartLine: CartLine): void {
    this.store.dispatch(openProductSupplementDialog({ cartIdentifier: this.cartId, cartLine }));
  }
}
